import en from 'commonAssets/i18n/en';
import es from 'commonAssets/i18n/es';

if (!es.hasOwnProperty('label')) {
    es['label'] = {};
}
en.language_switch = "Para leer el aviso en español, <a href='/es'>haga clic aquí</a>.";
es.language_switch = "To read the notice in English, <a href='/en'>click here</a>.";
en.contact_admin = "Send Message to Settlement Administrator";
es['label']['Payment Method'] = "Método de pago";
es['label']['Verizon Wireless Phone Number'] = "Número de teléfono de Verizon Wireless";
es['label']['Verizon Wireless Account Number'] = "N.° de cuenta de Verizon Wireless";

export default {
    en,
    es
};
